/************************************************************
 Physiotherapy Prescription Namespace
 ************************************************************/

window.physiotherapyPrescriptionNS = {
    _row: null,
    _action: null,
    _callback: null,

    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id);
        var actionId = parseInt(action.wf_action_id);
        var prescription_id = parseInt(row.prescription_id);

        physiotherapyPrescriptionNS._action = action;
        physiotherapyPrescriptionNS._row = row;
        physiotherapyPrescriptionNS._callback = callback;

        debug.log('PrescriptionID: ', row);
        debug.log('physiotherapyPrescrpitionNS executeAction:', actionId, globalConstants.ACTION_PRINT_MFR_PRESCRIPTION);

        if (actionId == globalConstants.ACTION_PRINT_MFR_PRESCRIPTION) {
            physiotherapyPrescriptionNS.printMfrPrescription(prescription_id);
        } else if (actionId == globalConstants.ACTION_CANCEL || actionId == globalConstants.ACTION_DISCONTINUE || actionId == globalConstants.ACTION_FINALIZE) {
            physiotherapyPrescriptionNS.executeGenericActionWithReason(); //IF needed, indicate a specific function to callback after reason confirm
        } else {
            physiotherapyPrescriptionNS.executeGenericAction(action, row, callback);
        }

    },

    printMfrPrescription: function (prescription_id) {

        debug.log('printMfrPrescription');
        var url = "/physiotherapy/prescription_list_report?prescription_id="+prescription_id;

        Hades.showDocument(url);
    },

    executeGenericAction: function (action, row, callback) {
        workflow.executeGenericAction(action, callback, row);
    },

    executeGenericActionWithReason: function (specific_callback) {
        workflow.openGenericReasonModal(specific_callback);
    }
};